import { IPresetDTO } from '@interfaces/kpi/dto/kpiDTO';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import { EVendorsLabels, EVendorsValues } from '@enums/common';
import { EAggregationTypes, EDateSelectionModes, EFormFields } from '@enums/kpi-api';

export const getParametersDefaultValues = (
	{
		defaultFrom,
		defaultTo,
		optionsVendorsKpi,
		initialVendor,
	}: {
		defaultFrom: number;
		defaultTo: number;
		optionsVendorsKpi:  Array<TSelectOptionType & { isDefault: boolean }>;
		initialVendor?: string;
	},
) => ({
	[EFormFields.aggregationType]: EAggregationTypes.aggregated,
	[EFormFields.from]: defaultFrom,
	[EFormFields.to]: defaultTo,
	[EFormFields.sitesT_4G_FDD]: [],
	[EFormFields.sitesT_4G_TDD]: [],
	[EFormFields.sitesT_5G]: [],
	[EFormFields.kpi]: [],
	[EFormFields.counters]: [],
	[EFormFields.treeKpiIds]: [],
	[EFormFields.treeCountersIds]: [],
	[EFormFields.initTreeKpiData]: [],
	[EFormFields.initTreeCountersData]: [],
	[EFormFields.timeAggregationType]: '',
	[EFormFields.vendor]: optionsVendorsKpi.find(vendor => vendor.value === initialVendor),
	[EFormFields.granularity]: null,
	[EFormFields.isAutomaticGranularity]: true,
	[EFormFields.dateSelectionMode]: EDateSelectionModes.static,
	[EFormFields.dynamicDateRange]: null,
	[EFormFields.startDateOffset]: null,
});

export const getPresetParametersDefaultValues = (
	{
		defaultFrom,
		defaultTo,
		formEditablePreset,
	}: {
		defaultFrom: number;
		defaultTo: number;
		formEditablePreset: IPresetDTO;
	},
) => ({
	[EFormFields.aggregationType]: EAggregationTypes.aggregated,
	[EFormFields.from]: defaultFrom,
	[EFormFields.to]: defaultTo,
	[EFormFields.sitesT_4G_FDD]: [],
	[EFormFields.sitesT_4G_TDD]: [],
	[EFormFields.sitesT_5G]: [],
	[EFormFields.kpi]: [],
	[EFormFields.counters]: [],
	[EFormFields.treeKpiIds]: [],
	[EFormFields.treeCountersIds]: [],
	[EFormFields.initTreeKpiData]: [],
	[EFormFields.initTreeCountersData]: [],
	[EFormFields.timeAggregationType]: '',
	[EFormFields.vendor]: {
		label: EVendorsLabels.oran,
		value: EVendorsValues.oran,
	},
	[EFormFields.granularity]: null,
	[EFormFields.isAutomaticGranularity]: formEditablePreset?.isAutomaticGranularity || false,
	[EFormFields.dateSelectionMode]: EDateSelectionModes.static,
	[EFormFields.dynamicDateRange]: null,
	[EFormFields.startDateOffset]: null,
	[EFormFields.isShared]: formEditablePreset?.isShared || false,
});
